import Box from "@mui/material/Box";
import { globalHistory } from "@reach/router";
import { type FC, type PropsWithChildren, useEffect } from "react";



export type SingleStepDrawerProps = PropsWithChildren<{
	hideDrawer: () => void;
	dataTest?: string;
}>

export const SingleStepDrawer: FC<SingleStepDrawerProps> = ({
	hideDrawer,
	children,
	dataTest,
}) => {
	useEffect(() => {
		return globalHistory.listen(({ action }) => {
			if (action === "POP") {
				hideDrawer();
			}
		});
	}, []);

	return (
		<Box
			data-test={dataTest}
			sx={{
				width: { md: "480px" },
				overflowY: "auto",
				py: 7,
				px: 4,
			}}
		>
			{children}
		</Box>
	);
}

